import { render, staticRenderFns } from "./ProgramElement.vue?vue&type=template&id=04f1cecb&scoped=true&"
import script from "./ProgramElement.vue?vue&type=script&lang=js&"
export * from "./ProgramElement.vue?vue&type=script&lang=js&"
import style0 from "./ProgramElement.vue?vue&type=style&index=0&id=04f1cecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1cecb",
  null
  
)

export default component.exports